import { useTranslations } from 'next-intl'
import { useFormContext, useWatch } from 'react-hook-form'

import { TBankCode } from '@/entities/account'
import { useDialog } from '@/shared/lib'
import { Form } from '@/shared/ui'

import { BankDialog } from './dialog'
import { useAccountVerification } from '../../lib/account-verification'

const DIALOG = 'BANK_SELECTOR'

type Props = {
  banks?: TBankCode[]
  readOnly?: boolean
}

export const BankSelector = ({ banks, readOnly }: Props) => {
  const t = useTranslations('deposit_information')

  const { open, isOpen, close } = useDialog()

  const {
    setValue,
    control,
    clearErrors,
    formState: { errors },
    setFocus,
  } = useFormContext()

  const { markAsUnverified } = useAccountVerification()

  const selectedBank = useWatch({
    name: 'bankName',
    control,
  })

  const handleTriggerClick = () => {
    open(DIALOG)
  }

  const handleDialogOpenChange = () => {
    close(DIALOG)
  }

  const handleItemClick = (value: string) => {
    if (errors?.bankName) {
      clearErrors('bankName')
    }

    if (errors?.accountHolder) {
      setValue('accountHolder', '')
      clearErrors(['root.accountServerError', 'accountHolder'])
      markAsUnverified()
    }

    setValue('bankName', value)
    close(DIALOG)

    setTimeout(() => {
      setFocus('bankAccount')
    }, 0)
  }

  return (
    <Form.Field name="bankName" className="space-y-0">
      <Form.SelectRoot width={120} open={false} readOnly={readOnly}>
        <Form.SelectTrigger onClick={handleTriggerClick}>
          <Form.SelectValue placeholder={t('bank.placeholder')} />
        </Form.SelectTrigger>
        <Form.SelectContent>
          {banks?.map(bank => (
            <Form.SelectItem key={bank.code} value={bank.name}>
              {bank.name}
            </Form.SelectItem>
          ))}
        </Form.SelectContent>
      </Form.SelectRoot>

      <BankDialog
        isOpen={isOpen(DIALOG)}
        selectedBank={selectedBank}
        onOpenChange={handleDialogOpenChange}
        onChange={handleItemClick}
        banks={banks}
      />
    </Form.Field>
  )
}
